import { Injectable } from '@angular/core';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  constructor(private logger: TCCPLoggerService, private httpService: TCCPHttpService) { }

  public appBase = TCCPConstantValues[environment.applicationName];
  public baseURL = this.appBase.Urls;

  getBanner(division: string, status: string, bannerId?: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
      'Started getting Banner', ''); /* banner / toyota / published */
    let url: string = null;
    if (bannerId) {
      url = this.baseURL.BANNER_CONTEXT + division + '/' + bannerId;
    } else {
      url = this.baseURL.BANNER_CONTEXT + 'banner/' + division + '/' + status;
    }
    /*  return this.httpService.get('../../../assets/data/admin/banners.json') */
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
            'Getting Banner successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.BANNER_MODULE, this.appBase.methods.getBanner,
            'Getting Banner failed', '', error);
          return error;
        })
        );
  }
}
